module.exports = __webpack_public_path__ + "static/media/report-login.bc99c971.svg";